<template>
  <div id="app">
  
  <!--/content-inner-->
	<div class="left-content" >
	   <div class="inner-content">
		<!-- header-starts -->
			<div class="header-section">
			<!-- top_bg -->
						<div class="top_bg">
								<div class="header_top">
									<div class="top_right">
										<ul>
											<li><a href="">SOFTWARE DEVELOPER</a></li>|
											<li><a href="">MOFEHINTOLU MUMUNI</a></li>
                                            
											</ul>
									</div>
									<div class="top_left">
										<h2> CONTACT ME : hello@mofehintolumumuni.com</h2>
									</div>
                                    	
										<div class="clearfix"> </div>
								</div>
						</div>
					<div class="clearfix"></div>
				<!-- /top_bg -->
				</div>
				<div class="header_bg">
							<div class="header">
								<div class="head-t">
									<div class="logo">
									
									<router-link to="/timeawards/" exact  style="color: rgb(197, 85, 10);"><strong>TIME PERSON OF THE YEAR AWARD</strong></router-link>
                  </div>
										<!-- start header_right -->
									<div class="header_right">
										
                          
									<div class="search">
										<form v-on:submit.prevent="handleSubmit()">
											<input type="text" placeholder="search awardees..." v-on:change="storeSearchString($event)">
											<input type="submit" value="">
										</form>
									</div>
									<div class="clearfix"> </div>
								</div>
								<div class="clearfix"> </div>
							</div>
						</div>
				</div>
					<!-- //header-ends -->
				<!--content-->
			<div class="content">
<div class="women_main">
	<!-- start content here-->

    <router-view></router-view>     

   <div class="clearfix"></div>
	<!-- end content -->
  
	<div class="foot-top">
	
		<div class="col-md-6 s-c">
			<li>
				<div class="fooll">
					<h1>Developer Bio</h1>
				</div>
			</li>
			<li>
			</br>
			<p>
			MOFEHINTOLU MUMUNI is a Web and Blockchain Software Engineer with very good knowledge of modern programming languages and frameworks.
			</p>
			</li>
				<div class="clearfix"> </div>
		</div>
	
			<div class="clearfix"> </div>
	
</div>
<div class="footer">

					<div class="clearfix"> </div>
						<p>© 2019 - {{this.currentYear}} TIME PERSON OF THE YEAR | Developed by <a href="http://mofehintolumumuni.com/" target="_blank">MOFEHINTOLU MUMUNI</a></p>
			</div>
</div>

</div>
			<!--content-->
		</div>
</div>
				<!--//content-inner-->
			<!--/sidebar-menu-->
				<div class="sidebar-menu">
					<header class="logo1">
						<a href="#" class="sidebar-icon"> <span class="fa fa-bars"></span> </a> 
					</header>
						<div style="border-top:1px ridge rgba(255, 255, 255, 0.15)"></div>
                           <div class="menu">
									<ul id="menu" >
										<li ><router-link to="/timeawards/" exact><i class="fa fa-tachometer"></i><span>Home</span></router-link></li>
									
										 <li id="menu-academico" ><a href="mailto:hello@mofehintolumumuni.com"><i class="fa fa-envelope"></i> <span>Mail developer</span></a></li>
									<li><a href="http://mofehintolumumuni.com" target="_blank"><i class="fa fa-globe"></i> <span>View developer website</span></a></li>
								
									 <li id="menu-academico" ><a href="#"><i class="fa fa-table"></i> <span>ADMIN PANEL</span> <span class="fa fa-angle-right" style="float: right"></span></a>
										   <ul id="menu-academico-sub" >
											<li id="menu-academico-avaliacoes" ><router-link to="/timeawards/signIn" exact>Admin signIn</router-link></li>
										<!--	<li id="menu-academico-avaliacoes" ><router-link to="/signUp" exact>Admin signUp</router-link></li>-->
											
										   <li id="menu-academico-avaliacoes" ><router-link to="/timeawards/storeProfile" exact>Store Profile</router-link></li>
											<li id="menu-academico-avaliacoes" ><router-link to="/timeawards/userDashboard" exact> Dashboard</router-link></li>
											<li id="menu-academico-avaliacoes" ><router-link to="/timeawards/passwordReset" exact> Reset Password</router-link></li>
									</ul>
										</li>
								  </ul>
								</div>
							  </div>
  </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue';
//import About from './components/AboutComponent.vue';
//import Contact from './components/ContactComponent.vue';
//import searchPage from './components/searchPage.vue';
//node graphql https://www.toptal.com/graphql/creating-your-first-graphql-api
//https://github.com/trevorblades/countries/tree/master/examples/react
  
export default {
  name: 'app',
  components: {
    //HelloWorld,
    //About,
    //Contact,
    //searchPage
  },
  data: function()
  {

       return {
                "searchString":null,
                "id":null,
				"currentYear": 2019
              }
     
  },
  mounted()
  {
	  let currentDate = new Date();
	  let year = currentDate.getFullYear();
	  this.currentYear = year;
  },
  methods:
  {
    storeSearchString: function(event)
    {
      this.searchString = event.target.value;
    },
    handleSubmit: function()
    {
      if((this.searchString != null) && (this.searchString != ""))
      {
        //redirect to search page with string value
        this.$router.push(`/timeawards/proxy/${this.searchString}`);
      }
      else{
           alert("Please fill search form properly before submitting");
      }
    }
  },
  computed:
  {

 
  }
}
// <HelloWorld msg="Welcome to Your Vue.js App"/>

</script>

<style>

</style>
